import CloseButton from 'components/DesignSystems/buttons/CloseButton';
import { ReactNode } from 'react';

interface WizardButtonWrapperProps {
  onModalClose: () => void;
  children?: ReactNode;
}

export default function WizardButtonWrapper({
  onModalClose,
  children,
}: WizardButtonWrapperProps) {
  return (
    <div className="mt-4">
      <div className="d-flex align-items-center gap-2">
        <CloseButton onClose={onModalClose} />
        {children}
      </div>
    </div>
  );
}
